import { getOfficeConsent } from './GetOfficeConsent';
import { acceptAllOfficeConsents } from './AcceptAllOfficeConsents';

export const ConsentsService = {
  getOfficeConsent,
  acceptAllOfficeConsents,
};
